import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
	padding: 1rem 0;
	background: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	position: sticky;
	top: 0;
	z-index: 1000;

	.ant-row-space-between {
		align-items: center;
		flex-wrap: nowrap;
		gap: 20px;
	}

	@media (max-width: 1200px) {
		padding: 1rem 15px;
	}
`;

export const NavLink = styled("div")`
	display: inline-block;
	text-align: center;
	vertical-align: middle;
	flex-shrink: 0;
`;

export const CustomNavLinkSmall = styled(NavLink)`
	font-size: 1rem;
	color: #18216d;
	transition: color 0.2s ease-in;
	margin: 0 1.2rem;
	white-space: nowrap;

	@media (max-width: 1200px) {
		margin: 0 0.8rem;
	}

	@media (max-width: 768px) {
		margin: 1rem 0.5rem;
	}
`;

export const Username = styled(CustomNavLinkSmall)`
	max-width: 280px;
	padding: 8px 16px;
	border-radius: 8px;
	transition: background 0.3s;
	display: flex;
	align-items: center;
	gap: 12px;
	background: transparent;
	cursor: pointer;
	line-height: 1.2;

	&:hover {
		background: #f8f9fa;
	}

	span {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		max-width: 200px;
	}

	@media (max-width: 992px) {
		max-width: 220px;
		padding: 6px 12px;

		span {
			max-width: 160px;
		}
	}

	@media (max-width: 768px) {
		max-width: 180px;

		span {
			max-width: 120px;
		}
	}

	@media (max-width: 480px) {
		max-width: 140px;

		span {
			max-width: 80px;
		}
	}
`;

export const LogoContainer = styled(Link)`
	flex: 0 0 auto;
	min-width: 180px;
	max-width: 300px;
	height: 64px;
	display: flex;
	align-items: center;

	@media (max-width: 992px) {
		min-width: 160px;
		max-width: 240px;
	}

	@media (max-width: 768px) {
		min-width: 120px;
		max-width: 180px;
	}
`;

export const Burger = styled("div")`
	display: none;
	cursor: pointer;
	padding: 8px;

	@media (max-width: 905px) {
		display: block;
	}

	svg {
		fill: #2e186a;
		font-size: 24px;
	}
`;

export const NotHidden = styled("div")`
	flex: 1;
	min-width: 0;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	@media (max-width: 905px) {
		display: none;
	}
`;

export const Menu = styled("h5")`
	margin-left: 80px;
	font-size: 1.5rem;
	font-weight: 600;
	text-align: center;

	@media (max-width: 992px) {
		margin-left: 40px;
		font-size: 1.3rem;
	}
`;

export const Label = styled("span")`
	font-weight: 500;
	color: #404041;
	display: block;
	margin-bottom: 8px;
`;

export const Outline = styled(MenuOutlined)`
	font-size: 24px;
	color: #2e186a;
`;

export const Span = styled("span")`
	cursor: pointer;
	transition: all 0.3s ease-in-out;
	display: inline-block;
	position: relative;

	&:hover,
	&:active,
	&:focus {
		color: #ff825c;
		transform: translateY(-1px);

		&::after {
			content: "";
			position: absolute;
			bottom: -4px;
			left: 0;
			right: 0;
			height: 2px;
			background: #ff825c;
			border-radius: 2px;
		}
	}
`;

export const ProfileWrapper = styled.div`
	display: flex;
	align-items: center;
	padding: 8px 16px;
	transition: background-color 0.3s;
	gap: 12px;
	width: 100%;

	&:hover {
		background-color: #f5f5f5;
	}

	> div {
		line-height: 1.4;
		overflow: hidden;
	}

	.ant-avatar {
		flex-shrink: 0;
	}
`;

export const styles = () => ({
	paper: {
		marginTop: "64px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		padding: "40px 24px",
		borderRadius: "16px",
		boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
	},
	avatar: {
		margin: "8px",
		backgroundColor: "#db4437",
		width: "64px",
		height: "64px",
	},
	form: {
		width: "100%",
		marginTop: "24px",
	},
	submit: {
		margin: "24px 0 16px",
		padding: "12px 24px",
		fontSize: "1.1rem",
		backgroundColor: "#4285f4",
		"&:hover": {
			backgroundColor: "#357abd",
		},
	},
	googleButton: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: "12px",
		textTransform: "none",
		fontWeight: 500,
		padding: "10px 24px",
		borderRadius: "8px",
	},
});

// Новые стили для адаптивности
export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
`;

export const NavigationWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
  justify-content: flex-end;
  min-width: 0;
`;

export const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;

  .ant-avatar {
    flex-shrink: 0;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
